import { HttpErrorResponse } from "@angular/common/http";

export class HttpErrorResponseUtils {
    //TODO: Esse método precisa ser melhorado com o tempo.
    static FormatErrorMessage(response: HttpErrorResponse): string {
        try {
            let error;

            if (response.error) {
                try {
                    error = JSON.parse(response.error);
                } catch (exception) {
                    error = response.error;
                }
            } else error = response;

            if (Array.isArray(error)) {
                let retorno = "Errors:";

                error.forEach((element) => {
                    retorno += "\n" + element;
                });

                return retorno;
            }

            //Errors do FluentValidation
            if (error.errors) {
                const keys = Object.keys(error.errors);
                let retorno = "Errors:";

                keys.forEach((key) => {
                    if (typeof error.errors[key] === "string" || error.errors[key] instanceof String)
                        retorno += "\n" + key + ": " + error.errors[key];
                    else
                        error.errors[key].forEach((element) => {
                            retorno += "\n" + element;
                        });
                });

                return retorno;
            }

            return error?.Message || error;
        } catch (ex) {
            return response.message;
        }
    }
}
